import { tooV1DiagnosticReportInitializeCustomControlData } from '@common/customControls/tooV1DiagnosticReportInitializeCustomControlData';
import { tooV1InitializeCustomControlData } from '@common/customControls/tooV1InitializeCustomControlData';
import { tooV1ProcedureInitializeCustomControlData } from '@common/customControls/tooV1ProcedureInitializeCustomControlData';
import { CustomControlEntity, ReportCategories, ServiceCode, ServiceType } from '@common/enums';
import { dermaCV1DiagnosticReportInitializeCustomControlData } from './DermaC/v1/DermaCV1DiagnosticReportAddEdit';
import { dermaCV1RequestInitializeCustomControlData } from './DermaC/v1/DermaCV1RequestAddEdit';
import { dermaCscV1DiagnosticReportInitializeCustomControlData } from './DermaCsc/v1/DermaCscV1DiagnosticReportAddEdit';
import { dermaCscV1RequestInitializeCustomControlData } from './DermaCsc/v1/DermaCscV1RequestAddEdit';
import { dermaCwondV1DiagnosticReportInitializeCustomControlData } from './DermaCwond/v1/DermaCwondV1DiagnosticReportAddEdit';
import { dermaCwondV1RequestInitializeCustomControlData } from './DermaCwond/v1/DermaCwondV1RequestAddEdit';
import { dermaOthV1DiagnosticReportInitializeCustomControlData } from './DermaOth/v1/DermaOthV1DiagnosticReportAddEdit';
import { dermaOthV1RequestInitializeCustomControlData } from './DermaOth/v1/DermaOthV1RequestAddEdit';
import { dermaSnelCV1DiagnosticReportInitializeCustomControlData } from './DermaSnelC/v1/DermaSnelCV1DiagnosticReportAddEdit';
import { dermaSnelCV1RequestInitializeCustomControlData } from './DermaSnelC/v1/DermaSnelCV1RequestAddEdit';
import { dermaSnelCscV1DiagnosticReportInitializeCustomControlData } from './DermaSnelCsc/v1/DermaSnelCscV1DiagnosticReportAddEdit';
import { dermaSnelCscV1RequestInitializeCustomControlData } from './DermaSnelCsc/v1/DermaSnelCscV1RequestAddEdit';
import { ggzbTherV1RequestInitializeCustomControlData } from './GGZBther/v1/GgzbTherV1RequestAddEdit';
import { ggzcf2fV1InitializeCustomControlData } from './GGZCf2f/v1/Ggzcf2fV1RequestAddEdit';
import { ggzcgV1DiagnosticReportInitializeCustomControlData } from './GGZCg/v1/GgzcgV1DiagnosticReportAddEdit';
import { ggzcgV1InitializeCustomControlData } from './GGZCg/v1/GgzcgV1RequestAddEdit';
import { ggzcmdoV1DiagnosticReportInitializeCustomControlData } from './GGZCmdo/v1/GgzcmdoV1DiagnosticReportAddEdit';
import { ggzcmdoV1RequestInitializeCustomControlData } from './GGZCmdo/v1/GgzcmdoV1RequestAddEdit';
import { ggzctV1InitializeCustomControlData } from './GGZCt/v1/GgzctV1RequestAddEdit';
import { ggzctriageV1DiagnosticReportInitializeCustomControlData } from './GGZCtriage/v1/GgzctriageV1DiagnosticReportAddEdit';
import { ggzctriageV1InitializeCustomControlData } from './GGZCtriage/v1/GgzctriageV1RequestAddEdit';
import { ggzoEmblV1RequestInitializeCustomControlData } from './GGZOembl/v1/GgzoEmblV1RequestAddEdit';
import { ggzoIntV1RequestInitializeCustomControlData } from './GGZOint/v1/GgzoIntV1RequestAddEdit';
import { ggzV1ReferralDischargeDiagnosticReportInitializeCustomControlData } from './GGZv/v1/GgzvV1DischargeDiagnosticReportAddEdit';
import { ggzV1ReferralIntakeDiagnosticReportInitializeCustomControlData } from './GGZv/v1/GgzvV1IntakeDiagnosticReportAddEdit';
import { ggzvV1InitializeCustomControlData } from './GGZv/v1/GgzvV1RequestAddEdit';
import { gtcV1DiagnosticReportInitializeCustomControlData } from './GTC/v1/GtcV1DiagnosticReportAddEdit';
import { gtcV1RequestInitializeCustomControlData } from './GTC/v1/GtcV1RequestAddEdit';
import { gtoV1DiagnosticReportInitializeCustomControlData } from './GTO/v1/GtoV1DiagnosticReportAddEdit';
import { gtoV1RequestInitializeCustomControlData } from './GTO/v1/GtoV1RequestAddEdit';
import { ocrkV1DiagnosticReportInitializeCustomControlData } from './OCRK/v1/utils/ocrkV1DiagnosticReportInitializeCustomControlData';
import { oorkV1DiagnosticReportInitializeCustomControlData } from './OORK/v1/utils/oorkV1DiagnosticReportInitializeCustomControlData';
import { oorkV1ProcedureInitializeCustomControlData } from './OORK/v1/utils/oorkV1ProcedureInitializeCustomControlData';
import { orthcV1DiagnosticReportInitializeCustomControlData } from './OrthC/v1/OrthCV1DiagnosticReportAddEdit';
import { orthOV1DiagnosticReportInitializeCustomControlData } from './OrthO/OrthOV1DiagnosticReportAddEditCustomControlFields';
import { orthOV1ProcedureInitializeCustomControlData } from './OrthO/orthOV1ProcedureInitializeCustomControlData';
import { orthOV1RequestInitializeCustomControlData } from './OrthO/OrthOV1RequestAddEdit';
import { orthOFolV1RequestInitializeCustomControlData } from './OrthOFol/v1/OrthOFolV1RequestAddEdit';
import { osasc1V1DiagnosticReportInitializeCustomControlData } from './OSASC1/v1/Osasc1V1DiagnosticReportAddEditCustomControlFields';
import { osasc2V1DiagnosticReportInitialize } from './OSASC2/v1/Osasc2V1DiagnosticReportAddEdit';
import { osasc2V2DiagnosticReportInitialize } from './OSASC2/v2/Osasc2V2DiagnosticReportAddEdit';
import { osaseV1RequestInitializeCustomControlData } from './OSASE/contact/v1/OsaseV1RequestAddEdit';
import { osaseV2RequestInitializeCustomControlData } from './OSASE/contact/v2/OsaseV2RequestAddEdit';
import { osasendV1RequestInitializeCustomControlData } from './OSASEND/contact/v1/OsasendV1RequestAddEdit';
import { osasnV1RequestInitializeCustomControlData } from './OSASN/contact/v1/OsasnV1RequestAddEdit';
import { osasoV1DiagnosticReportInitialize } from './OSASO/v1/OsasoV1DiagnosticReportAddEdit';
import { osasoV1ProcedureInitialize } from './OSASO/v1/OsasoV1ProcedureDiagnosticReportAddEdit';
import { osasoV1RequestInitializeCustomControlData } from './OSASO/v1/OsasoV1RequestAddEdit';
import { osasqV1RequestInitializeCustomControlData } from './OSASQ/v1/OsasqV1RequestAddEdit';
import { osasvV1InitializeCustomControlData } from './OSASV/v1/OsasvV1RequestAddEdit';
import { osasvcV1RequestInitializeCustomControlData } from './OSASVC/contact/v1/OsasvcV1RequestAddEdit';
import { osasvcV2RequestInitializeCustomControlData } from './OSASVC/contact/v2/OsasvcV2RequestAddEdit';
import { osasvoV1DiagnosticReportInitialize } from './OSASVO/v1/OsasvoV1DiagnosticReportAddEdit';
import { osasvoV1ProcedureInitialize } from './OSASVO/v1/OsasvoV1ProcedureDiagnosticReportAddEdit';
import { osasvoV1RequestInitializeCustomControlData } from './OSASVO/v1/OsasvoV1RequestAddEdit';
import { pilotConsultationV1DiagnosticReportInitializeCustomControlData } from './PILOT/consultation/v1/PilotConsultationV1DiagnosticReportAddEdit';
import { pilotConsultationV1RequestInitializeCustomControlData } from './PILOT/consultation/v1/PilotConsultationV1RequestAddEdit';
import { pilotContactV1RequestInitializeCustomControlData } from './PILOT/contact/v1/PilotContactV1RequestAddEdit';
import { pilotExaminationV1DiagnosticReportInitializeCustomControlData } from './PILOT/examination/v1/PilotExaminationV1DiagnosticReportAddEditCustomControlFields';
import { pilotExaminationV1ProcedureInitializeCustomControlData } from './PILOT/examination/v1/PilotExaminationV1ProcedureAddEdit';
import { pilotExaminationV1RequestInitializeCustomControlData } from './PILOT/examination/v1/PilotExaminationV1RequestAddEdit';
import { pilotExaminationV1SupervisionInitializeCustomControlData } from './PILOT/examination/v1/PilotExaminationV1SupervisionEdit';
import { PilotReferralV1DischargeDiagnosticReportInitializeCustomControlData } from './PILOT/referral/v1/PilotReferralV1DischargeDiagnosticReportAddEdit';
import { PilotReferralV1IntakeDiagnosticReportInitializeCustomControlData } from './PILOT/referral/v1/PilotReferralV1IntakeDiagnosticReportAddEdit';
import { pilotReferralV1RequestInitializeCustomControlData } from './PILOT/referral/v1/PilotReferralV1RequestAddEdit';
import { pilotReferralSmallV1RequestInitializeCustomControlData } from './PILOT/referralSmall/v1/PilotReferralSmallV1RequestAddEdit';
import { initializeCustomControlDataRustEcg, tcorV1InitializeCustomControlDataRustEcg } from './TCCr/v1/RustEcgAddEdit';
import { tccrV1DiagnosticReportInitializeCustomControlData } from './TCCr/v1/TccrV1DiagnosticReportAddEdit';
import { tcohV1DiagnosticReportInitializeCustomControlData } from './TCOH/v1/TcohV1DiagnosticReportAddEditCustomControlFields';
import {
    tcohV2ProcedureInitializeCustomControlData,
    tcohV2RequestInitializeCustomControlData,
} from './TCOH/v2/customControlData';
import { tcohV2DiagnosticReportInitializeCustomControlData } from './TCOH/v2/TcohV2DiagnosticReportAddEditCustomControlFields';
import { tcorV1DiagnosticReportInitializeCustomControlData } from './TCOR/v1/TcorV1DiagnosticReportAddEditCustomControlFields';
import { tcorV1InitializeCustomControlData } from './TCOR/v1/TcorV1RequestAddEdit';
import { tfcV1DiagnosticReportInitializeCustomControlData } from './TFC/v1/TfcV1DiagnosticReportAddEdit';
import { tfcV1InitializeCustomControlData } from './TFC/v1/TfcV1RequestAddEdit';
import { tfoV1DiagnosticReportInitializeCustomControlData } from './TFO/v1/TfoV1DiagnosticReportAddEditCustomControlFields';
import { tfoV1ProcedureInitializeCustomControlData } from './TFO/v1/TfoV1ProcedureAddEdit';
import { tfoV1InitializeCustomControlData } from './TFO/v1/TfoV1RequestAddEdit';
import { tfoV1SupervisionInitializeCustomControlData } from './TFO/v1/TfoV1SupervisionEdit';
import { tiecgV1DiagnosticReportInitializeCustomControlData } from './TIECG/v1/TiecgV1DiagnosticReportAddEditCustomControlFields';
import { tiecgV1ProcedureInitializeCustomControlData } from './TIECG/v1/TiecgV1ProcedureAddEdit';
import { tiecgV1InitializeCustomControlData } from './TIECG/v1/TiecgV1RequestAddEdit';
import { tocV1DiagnosticReportInitializeCustomControlData } from './TOC/v1/TocV1DiagnosticReportAddEdit';
import { tovV1ReferralDischargeDiagnosticReportInitializeCustomControlData } from './TOV/v1/TovV1DischargeDiagnosticReportAddEdit';
import { tovV1ReferralIntakeDiagnosticReportReportInitializeCustomControlData } from './TOV/v1/TovV1IntakeDiagnosticReportAddEdit';
import { tovV1RequestInitializeCustomControlData } from './TOV/v1/TovV1RequestAddEdit';
import { initializeCustomControlDataSpirometry } from './TPC/v1/SpirometryAddEdit';
import { tpcV1DiagnosticReportInitializeCustomControlData } from './TPC/v1/TpcV1DiagnosticReportAddEdit';
import { tpoV1DiagnosticReportInitializeCustomControlData } from './TPO/v1/TpoV1DiagnosticReportAddEditCustomControlFields';

export function initializeCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.RequestAddEdit,
    serviceCode: ServiceCode,
    serviceType: ServiceType
    // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
): Object | null;
export function initializeCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.ProcedureAddEdit,
    serviceCode: ServiceCode,
    serviceType: ServiceType,
    isDirectProcedureAdded?: boolean
    // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
): Object | null;
export function initializeCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.SupervisionEdit,
    serviceCode: ServiceCode,
    serviceType: ServiceType
    // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
): Object | null;
export function initializeCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.DiagnosticReportAddEdit,
    serviceCode: ServiceCode,
    serviceType: ServiceType,
    isDirectProcedureAdded: boolean | undefined,
    category: ReportCategories
    // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
): Object | null;
export function initializeCustomControl(
    version: number,
    customControlEntity: CustomControlEntity,
    serviceCode: ServiceCode,
    serviceType: ServiceType,
    isDirectProcedureAdded?: boolean,
    category?: ReportCategories
    // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
): Object | null {
    if (serviceCode === ServiceCode.TPC) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return initializeCustomControlDataSpirometry('request');
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tpcV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.TIECG) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return tiecgV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tiecgV1DiagnosticReportInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return tiecgV1ProcedureInitializeCustomControlData();
            }
        }
    } else if (
        serviceCode === ServiceCode.TCCr ||
        serviceCode === ServiceCode.TCCh ||
        serviceCode === ServiceCode.TCCi
    ) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return initializeCustomControlDataRustEcg();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tccrV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.TPO) {
        if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tpoV1DiagnosticReportInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return initializeCustomControlDataSpirometry('procedure');
            }
        }
    } else if (serviceCode === ServiceCode.TCOH) {
        if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tcohV1DiagnosticReportInitializeCustomControlData();
            } else if (version === 2) {
                return tcohV2DiagnosticReportInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1 || version === 2) {
                return tcohV2ProcedureInitializeCustomControlData(isDirectProcedureAdded);
            }
        } else if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1 || version === 2) {
                return tcohV2RequestInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.TCOR) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return tcorV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tcorV1DiagnosticReportInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return tcorV1InitializeCustomControlDataRustEcg(isDirectProcedureAdded);
            }
        }
    } else if (serviceCode === ServiceCode.PILOT) {
        if (serviceType === ServiceType.examination) {
            if (customControlEntity === CustomControlEntity.RequestAddEdit) {
                if (version === 1) {
                    return pilotExaminationV1RequestInitializeCustomControlData();
                }
            } else if (customControlEntity === CustomControlEntity.SupervisionEdit) {
                if (version === 1) {
                    return pilotExaminationV1SupervisionInitializeCustomControlData();
                }
            } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
                if (version === 1) {
                    return pilotExaminationV1ProcedureInitializeCustomControlData();
                }
            } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
                if (version === 1) {
                    return pilotExaminationV1DiagnosticReportInitializeCustomControlData();
                }
            }
        } else if (serviceType === ServiceType.referralSmall) {
            if (customControlEntity === CustomControlEntity.RequestAddEdit) {
                if (version === 1) {
                    return pilotReferralSmallV1RequestInitializeCustomControlData();
                }
            }
        } else if (serviceType === ServiceType.referral) {
            if (customControlEntity === CustomControlEntity.RequestAddEdit) {
                if (version === 1) {
                    return pilotReferralV1RequestInitializeCustomControlData();
                }
            } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
                if (category === ReportCategories.intake) {
                    if (version === 1) {
                        return PilotReferralV1IntakeDiagnosticReportInitializeCustomControlData();
                    }
                } else if (category === ReportCategories.discharge) {
                    if (version === 1) {
                        return PilotReferralV1DischargeDiagnosticReportInitializeCustomControlData();
                    }
                }
            }
        } else if (serviceType === ServiceType.consultation) {
            if (customControlEntity === CustomControlEntity.RequestAddEdit) {
                if (version === 1) {
                    return pilotConsultationV1RequestInitializeCustomControlData();
                }
            } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
                if (version === 1) {
                    return pilotConsultationV1DiagnosticReportInitializeCustomControlData();
                }
            }
        } else if (serviceType === ServiceType.contact) {
            if (customControlEntity === CustomControlEntity.RequestAddEdit) {
                if (version === 1) {
                    return pilotContactV1RequestInitializeCustomControlData();
                }
            }
        }
    } else if (serviceCode === ServiceCode.OSASO) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return osasoV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return osasoV1DiagnosticReportInitialize();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return osasoV1ProcedureInitialize();
            }
        }
    } else if (serviceCode === ServiceCode.OSASVO) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return osasvoV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return osasvoV1DiagnosticReportInitialize();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return osasvoV1ProcedureInitialize();
            }
        }
    } else if (serviceCode === ServiceCode.OSASQ) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return osasqV1RequestInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OSASC1) {
        if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return osasc1V1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OSASC2) {
        if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return osasc2V1DiagnosticReportInitialize();
            } else if (version === 2) {
                return osasc2V2DiagnosticReportInitialize();
            }
        }
    } else if (serviceCode === ServiceCode.OSASV) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return osasvV1InitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OSASEND) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return osasendV1RequestInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OSASN) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return osasnV1RequestInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OSASVC) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return osasvcV1RequestInitializeCustomControlData();
            } else if (version === 2) {
                return osasvcV2RequestInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OSASE) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return osaseV1RequestInitializeCustomControlData();
            } else if (version === 2) {
                return osaseV2RequestInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GGZCg) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return ggzcgV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return ggzcgV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GGZCt) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return ggzctV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return ggzcgV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GGZCtriage) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return ggzctriageV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return ggzctriageV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GGZCf2f) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return ggzcf2fV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return ggzcgV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GGZCmdo) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return ggzcmdoV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return ggzcmdoV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GGZv) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return ggzvV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (!category) {
                throw new Error(`Category missing for ${customControlEntity} in initializeCustomControl`);
            }

            if (category === ReportCategories.intake) {
                if (version === 1) {
                    return ggzV1ReferralIntakeDiagnosticReportInitializeCustomControlData();
                }
            }

            if (category === ReportCategories.discharge) {
                if (version === 1) {
                    return ggzV1ReferralDischargeDiagnosticReportInitializeCustomControlData();
                }
            }
        }
    } else if (serviceCode === ServiceCode.GGZOint) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return ggzoIntV1RequestInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GGZOembl) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return ggzoEmblV1RequestInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GGZBther) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return ggzbTherV1RequestInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GTO) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return gtoV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return gtoV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.TFO) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return tfoV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return tfoV1ProcedureInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tfoV1DiagnosticReportInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.SupervisionEdit) {
            if (version === 1) {
                return tfoV1SupervisionInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.TOO) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return tooV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return tooV1ProcedureInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tooV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.TOC) {
        if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tocV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.TOV) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return tovV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (!category) {
                throw new Error(`Category missing for ${customControlEntity} in initializeCustomControl`);
            }

            if (category === ReportCategories.intake) {
                if (version === 1) {
                    return tovV1ReferralIntakeDiagnosticReportReportInitializeCustomControlData();
                }
            }

            if (category === ReportCategories.discharge) {
                if (version === 1) {
                    return tovV1ReferralDischargeDiagnosticReportInitializeCustomControlData();
                }
            }
        }
    } else if (serviceCode === ServiceCode.TFC) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return tfcV1InitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return tfcV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.GTC) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return gtcV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return gtcV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.DermaCwond) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return dermaCwondV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return dermaCwondV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.DermaC) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return dermaCV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return dermaCV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.DermaSnelC) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return dermaSnelCV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return dermaSnelCV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.DermaCsc) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return dermaCscV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return dermaCscV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.DermaSnelCsc) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return dermaSnelCscV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return dermaSnelCscV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.DermaOth) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return dermaOthV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return dermaOthV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OrthO) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return orthOV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return orthOV1ProcedureInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return orthOV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OrthOFol) {
        if (customControlEntity === CustomControlEntity.RequestAddEdit) {
            if (version === 1) {
                return orthOFolV1RequestInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return orthOV1ProcedureInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return orthOV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OrthC) {
        if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return orthcV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OORK) {
        if (customControlEntity === CustomControlEntity.ProcedureAddEdit) {
            if (version === 1) {
                return oorkV1ProcedureInitializeCustomControlData();
            }
        } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return oorkV1DiagnosticReportInitializeCustomControlData();
            }
        }
    } else if (serviceCode === ServiceCode.OCRK) {
        if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
            if (version === 1) {
                return ocrkV1DiagnosticReportInitializeCustomControlData();
            }
        }
    }

    return null;
}
